import { Flex } from "@chakra-ui/react";

export default function RelaySetView() {
  return (
    <Flex gap="2" direction="column">
      Relay Set
    </Flex>
  );
}
